<template>
  <div class="form-input" :class="{ 'expand-on-focus': expandOnFocus }">
    <label>{{ label }}</label>

    <Field
      v-slot="{ field, errorMessage }: FieldSlot"
      :model-value="modelValue"
      :name="name"
      :rules="rules"
      @update:model-value="emitModelValue"
    >
      <select v-bind="field" class="form-control" :disabled="disabled" :multiple="multiple">
        <option
          v-for="option in options"
          :key="option.code || 'undefined'"
          :value="option.code"
          v-text="option.label"
        />
      </select>

      <div v-show="errorMessage" class="text-danger">{{ errorMessage }}</div>
    </Field>

    <slot name="extra" />
  </div>
</template>

<script lang="ts" setup>
import type { RuleExpression } from 'vee-validate';
import { Field } from 'vee-validate';
import type { FieldSlot } from '../../types';

export interface SelectProps {
  options: { label: string; code: string | number | boolean | undefined }[];
  label: string;
  modelValue: string | number | boolean | undefined;
  name: string;
  disabled?: boolean;
  multiple?: boolean;
  rules?: RuleExpression<unknown>;
  expandOnFocus?: boolean;
}

const props = withDefaults(defineProps<SelectProps>(), {
  options: () => [],
  label: () => '',
});

const emit = defineEmits({
  'update:modelValue': (value: string | number | boolean) => value,
  blur: (value: string | number | boolean) => value,
  focus: (value: boolean) => value,
});

const emitModelValue = (newValue: any) => {
  emit('update:modelValue', newValue);
};
</script>

<style>
.form-input.expand-on-focus select:focus {
  min-width: 350px;
}

.form-input.expand-on-focus {
  overflow: hidden;
}
</style>
